import { modifyPartnerDetails, modifyPartnerListing } from '../common/utilities';
import { API_PATH } from '../constants/api-constants';
import { getAPIParams } from '../utils/filter.util';
import { READ } from './actionTypes';

const {
  API_V1,
  PARTNERS_SUCCESS_STORIES,
  PARTNERS_FILTER,
  PARTNERS_LISTING,
  PARTNERS_FILTER_STATUS, PARTNER_DETAIL,
} = API_PATH;
const getPartnersSuccessStories = (param = '') => READ(`${API_V1}${PARTNERS_SUCCESS_STORIES}/${param}`);
const getPartnersFilters = () => READ(`${API_V1}${PARTNERS_FILTER}`);
const getFilterStatus = (params = '') => READ(`${API_V1}${PARTNERS_FILTER_STATUS}?${params}`);
const getPartners = async (params = '') => {
  try {
    const apiParams = getAPIParams(params);
    const response = await READ(`${API_V1}${PARTNERS_LISTING}?${apiParams}`);
    return modifyPartnerListing(response);
  } catch (error) {
    console.error('Error fetching partners:', error);
    throw error;
  }
};
const getPartnerDetail = async (partnerId) => {
  try {
    const response = await READ(`${API_V1}${PARTNER_DETAIL}${partnerId}`);
    return modifyPartnerDetails(response);
  } catch (error) {
    console.error('Error fetching partner details:', error);
    throw error;
  }
};

export {
  getPartners,
  getPartnersSuccessStories,
  getPartnersFilters,
  getFilterStatus,
  getPartnerDetail,
};
